import { render, staticRenderFns } from "./Grade10DocumentDetail.vue?vue&type=template&id=40318eb1&scoped=true&"
import script from "./Grade10DocumentDetail.vue?vue&type=script&lang=js&"
export * from "./Grade10DocumentDetail.vue?vue&type=script&lang=js&"
import style0 from "./Grade10DocumentDetail.vue?vue&type=style&index=0&id=40318eb1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40318eb1",
  null
  
)

export default component.exports